import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationService } from '../_service/notification.service';
import { CommonService } from '../_service/common.service';

const HTTP_STATUS_SERVER_ERROR = 500;
const HTTP_STATUS_UNAUTHORIZED = 401;
const CUSTOM_ERROR_CODE_RELOAD = 107;

@Injectable({
  providedIn: 'root'  // <- ADD THIS
})
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(public commonService:CommonService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // localStorage.removeItem('errorCode');
    // localStorage.removeItem('errorReqId');
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          let errorMsg = '';
          if (error.error instanceof ErrorEvent) {
            console.info('this is client side error');
            errorMsg = `Error: ${error.error.message}`;
          }
          else {
            console.info('this is server side error');
            errorMsg = `Error Code: ${error.status},  Message: ${error.message}`;
            this.errorFunction(error);
          }
          console.info(errorMsg);
          return throwError(errorMsg);
        })
      )
  }

  errorFunction(error) {
    console.info("error====>", error);
    let url = error.url.split('/');
    console.info("url====>", url);
    let re = 'k2-isa';
    let is_K2ValidationUrl = false;
    if(url[3]){
    console.info("url[3].search(re)===>", url[3].search(re));
    url.forEach(ele => {
      if (ele.indexOf('comment') > -1) {
        is_K2ValidationUrl = true
      }
    })
    if (url[3] && url[3].search(re) != -1 && error.status == HTTP_STATUS_SERVER_ERROR && is_K2ValidationUrl) {
      // CommonService.errorCode = error.status;
      let elementClose = document.getElementById('closeWorkflowRejection') as HTMLElement;
      elementClose.click();

      let elementClose1 = document.getElementById('closeWorkflowValidation') as HTMLElement;
      elementClose1.click();

      localStorage.setItem('errorCode', error.status);

      // let atag = '  <a href="mailto:isa@renault.com?subject=ISA - 161" style="text-decoration: underline;color: #47525E;">isa@renault.com</a>';
      // let message = "An unexpected error occured while processing. Please contact" +atag+ "for assistance.";
      // localStorage.setItem('errorMessage', message);

      console.info("commings....");
      // if(url[3]=="k2-socle" && error.status=="500") {
      // document.getElementById("httpErrorInterceptors").click;
      let element = document.getElementById('errorPopup') as HTMLElement;
      element.click();
      console.info("commings yes....");

    }
  }
    if (error.status == CUSTOM_ERROR_CODE_RELOAD) {
      window.location.reload();
    }
    const baseUrl2 =
    `https:${window.location.origin.substring(window.location.protocol.length)}`;
    if ((baseUrl2!="https://localhost:4200" )&& (url[3] && (url[3].search("k2-socle")!=-1 || is_K2ValidationUrl)) && error.status==HTTP_STATUS_UNAUTHORIZED){
      console.info("K2 Authentication Issue",error)
          window.location.reload();

  }
  }
}